import React, { useState } from 'react';
import styles from './AboutPage.module.css';
import NewFeaturesAccordion from './../../components/NewFeaturesAccordion/NewFeaturesAccordion';
import MarkdownTabContent from './../../components/MarkdownTabContent/MarkdownTabContent';
import CompactNavbar from './../../components/CompactNavbar/CompactNavbar';
import Breadcrumb from './../../components/Breadcrumb/Breadcrumb';
import { useAuth } from "./../../utils/AuthContext/authcontext";
import ContactSidebar from './../../components/ContactSidebar/ContactSidebar';
import { useTranslation } from 'react-i18next';
import Button from '../../components/ui/Button';


export default function AboutPage() {
  const [activeTab, setActiveTab] = useState('features');
  const [isContactOpen, setContactOpen] = useState(false);
  const {user, logout} = useAuth();
  const { t } = useTranslation();

  const mlogout = () => {
  }

  return (
    <>
	<div className={styles.header}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
    <div className={styles.container}>
	<Breadcrumb />
      <div className={styles.tabBar}>
        <Button
          variant={activeTab === 'about' ? 'primary' : 'ghost'}
          className={activeTab === 'about' ? styles.active : ''}
          onClick={() => setActiveTab('about')}
        >
          {t('ui.aboutRatio')}
        </Button>
        <Button
          variant={activeTab === 'features' ? 'primary' : 'ghost'}
          className={activeTab === 'features' ? styles.active : ''}
          onClick={() => setActiveTab('features')}
        >
          {t('ui.newFeatures')}
        </Button>
        <Button
          variant={activeTab === 'terms' ? 'primary' : 'ghost'}
          className={activeTab === 'terms' ? styles.active : ''}
          onClick={() => setActiveTab('terms')}
        >
          {t('ui.termsAndConditions')}
        </Button>
        <Button
          variant={activeTab === 'privacy' ? 'primary' : 'ghost'}
          className={activeTab === 'privacy' ? styles.active : ''}
          onClick={() => setActiveTab('privacy')}
        >
          {t('ui.privacyPolicy')}
        </Button>
      </div>

      <div className={styles.tabContent}>
        {activeTab === 'features' && <NewFeaturesAccordion />}
        {activeTab === 'terms' && <MarkdownTabContent docId="terms" />}
        {activeTab === 'privacy' && <MarkdownTabContent docId="privacy" />}
        {activeTab === 'about' && <MarkdownTabContent docId="about" />}
      </div>
    </div>
	<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	</>
  );
}
